import { render } from "./TotalMaterials.vue?vue&type=template&id=9d5529bc&scoped=true"
import script from "./TotalMaterials.vue?vue&type=script&lang=js"
export * from "./TotalMaterials.vue?vue&type=script&lang=js"

import "./TotalMaterials.vue?vue&type=style&index=0&id=9d5529bc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Keith\\Dropbox\\WebStorm\\Projects\\slumbernot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5529bc"]])

export default __exports__